export default {
    name: 'SelectDropdown',
    props: {
        dropdownValue: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        },
        uniqueKey: {
            type: String,
            default: '_id'
        },
        label: {
            type: String,
            default: 'label'
        },
        placeholder: {
            type: String,
            default: 'Select'
        },
        width: {
            type: String,
            default: '100%'
        }
    },
    data() {
        return {
            // value: ''
        }
    },
    computed: {
        value: {
            get(){
                return this.dropdownValue
            },
            
            set(newValue) {
                return newValue
            } 
        }
    }
}